import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const videos = [
  { id: 1, src: "../videos/zee-Ramgarh-Dam-Jaipur.mp4" },
  { id: 2, src: "../videos/First-India-News.mp4" },
  { id: 3, src: "../videos/Rajasthan-Patrika.mp4" },
];

function VideoSlider() {
  const sliderRef = useRef(null);
  const videoRefs = useRef([]);

  // Reset refs array on every render
  useEffect(() => {
    videoRefs.current = videoRefs.current.slice(0, videos.length);
  }, []);

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (i !== index && video && !video.paused) {
        video.pause();
      }
    });
  };

  const settings = {
    arrows: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,

    rows: 1,
    slidesPerRow: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, rows: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, rows: 1 } },
    ],
  };

  return (
    <div className="video-slider-container" style={{ padding: "20px" }}>
      <Slider ref={sliderRef} {...settings}>
        {videos.map((video, index) => (
          <div
            key={video.id}
            className="video-slide video-height"
            style={{ padding: "10px" }}
          >
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              src={video.src}
              controls
              onPlay={() => handlePlay(index)}
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default VideoSlider;
